import React from "react";
import { Routes, Route } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";
import Products from "../pages/Pawn/Products/AllProduct";
import BorrowItems from "../pages/Pawn/Products/BorrowItems";
import BuyItems from "../pages/Pawn/Products/BuyItems";
import OverdueBorrowItems from "../pages/Pawn/Products/OverdueBorrowItems";
import OverduePawnItems from "../pages/Pawn/Products/OverduePawnItems";
import ReadyItems from "../pages/Pawn/Products/ReadyItems";
import SoldItems from "../pages/Pawn/Products/SoldItems";
import SellOnConsignmen from "../pages/Pawn/List/SellOnConsignmen";
import ListByCustomer from "../pages/Pawn/List/ListByCustomer";
import Bin from "../pages/Pawn/List/Bin";
import RedemptionItems from "../pages/Pawn/List/RedemptionItems";
import SettingPrice from "../pages/Pawn/List/SettingPrice";
import CustomerList from "../pages/Pawn/List/CustomerList";
import Inventory from "../pages/Pawn/Report/Inventory";
import IncomeExpenes from "../pages/Pawn/Report/IncomeExpenses";
import Interest from "../pages/Pawn/Report/Interest";
import ImportData from "../pages/Pawn/ImportRetrospectiveData/ImportData";
import ImportInformationBuy from "../pages/Pawn/ImportRetrospectiveData/ImportInformationPawn";
import ImportInformationPawn from "../pages/Pawn/ImportRetrospectiveData/ImportInformationBuy";
import ImportList from "../pages/Pawn/ImportRetrospectiveData/ImportList";
import Dashboard from "../pages/Dashboard";

const LandRoutes = ({ permissions }) => {
  return (
    <Routes>
      <Route path="/" element={<LandChildRoutes permissions={permissions} />} />
    </Routes>
  );
};

const LandChildRoutes = ({ permissions }) => {
  return (
    <Routes>
      <Route path="dashboard_land" element={<Dashboard />} />
      {hasPermission(permissions, [
        "List_Products",
        "Edit_Products",
        "Land",
      ]) && (
        <>
          <Route path="all_product_land" element={<Products />} />
          <Route path="buy_items_land" element={<BuyItems />} />
          <Route path="ready_items_land" element={<ReadyItems />} />
          <Route path="borrow_items_land" element={<BorrowItems />} />
          <Route
            path="overdue_borrow_items_land"
            element={<OverdueBorrowItems />}
          />
          <Route path="sold_items_land" element={<SoldItems />} />
          <Route
            path="overdue_pawn_items_land"
            element={<OverduePawnItems />}
          />
        </>
      )}

      {hasPermission(permissions, ["List1", "Edit_List1", "Land"]) && (
        <>
          <Route
            path="sell_on_consignmen_land"
            element={<SellOnConsignmen />}
          />
          <Route path="redemption_items_land" element={<RedemptionItems />} />
          <Route path="setting_price_land" element={<SettingPrice />} />
          <Route path="list_by_customer_land" element={<ListByCustomer />} />
          <Route path="bin_land" element={<Bin />} />
          <Route path="customer_list_land" element={<CustomerList />} />
        </>
      )}

      {hasPermission(permissions, ["List_Report", "Edit_Report", "Land"]) && (
        <>
          <Route path="inventory_land" element={<Inventory />} />
          <Route path="income_expenses_land" element={<IncomeExpenes />} />
          <Route path="interest_land" element={<Interest />} />
        </>
      )}

      {hasPermission(permissions, ["List_Import", "Edit_Import", "Land"]) && (
        <>
          <Route path="import_data_land" element={<ImportData />} />
          <Route
            path="import_information_land"
            element={<ImportInformationPawn />}
          />
          <Route
            path="import_information_buy_land"
            element={<ImportInformationBuy />}
          />
          <Route path="import_list_land" element={<ImportList />} />
        </>
      )}
    </Routes>
  );
};

export default LandRoutes;
